import React, { useState } from "react";
import Header from "../components/Header";
import {
  createProject,
  createProjectActive,
  dashboard,
  dashboardActive,
  logout,
  projectList,
  projectListActive,
} from "../assets";
import { useNavigate } from "react-router-dom";
import { AddProject } from "../components/AddProject";
import Dashboard from "../components/Dashboard";
import ProjectList from "../components/ProjectList";
import { useDispatch } from "react-redux";
import { clearUser } from "../redux/userSlice";
import toast from "react-hot-toast";

const Admin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [select, setSelect] = useState("dashboard");
  const renderComponent = () => {
    switch (select) {
      case "dashboard":
        return <Dashboard />;
      case "projectlist":
        return <ProjectList />;
      case "createproject":
        return <AddProject />;
      default:
        return <Dashboard />;
    }
  };

  const logoutFun = () => {
    dispatch(clearUser());
    navigate("/");
    toast.success("Logged out!")
  };
  return (
    <div className="admin relative text-sm ">
      <div className="sidebar hidden fixed h-screen lg:block p-6 shadow-2xl bg-white lg:flex flex-col gap-8 lg:top-0 lg:left-0 items-center justify-center">
        <div className=" flex items-center gap-8 flex-col">
          <div className=" relative">
            {select === "dashboard" && (
              <div className=" absolute -top-2 -start-9 bg-primary rounded-3xl h-10 p-2 w-2 " />
            )}
            <img
              src={select === "dashboard" ? dashboardActive : dashboard}
              alt="dashboard"
              onClick={() => setSelect("dashboard")}
              className=" cursor-pointer"
            />
          </div>
          <div className=" relative">
            {select === "projectlist" && (
              <div className=" absolute -top-2 -start-9 bg-primary rounded-3xl h-10 p-2 w-2 " />
            )}{" "}
            <img
              src={select === "projectlist" ? projectListActive : projectList}
              alt="list"
              onClick={() => setSelect("projectlist")}
              className=" cursor-pointer"
            />
          </div>
          <div className="relative">
            <div className=" w-6 bg-gray-400 p-[0.5px]" />
          </div>
          <div className=" relative">
            {select === "createproject" && (
              <div className=" absolute -top-2 -start-9 bg-primary rounded-3xl h-10 p-2 w-2 " />
            )}{" "}
            <img
              src={
                select === "createproject" ? createProjectActive : createProject
              }
              alt="create"
              onClick={() => setSelect("createproject")}
              className=" cursor-pointer"
            />
          </div>
          <div className=" absolute bottom-4 z-50">
            <img src={logout} onClick={logoutFun} alt="logout" className=" cursor-pointer" />
          </div>
        </div>
      </div>
      <div className="bottom-bar lg:hidden fixed bottom-0 w-full flex justify-center items-center z-50 ">
        <div className=" shadow-lg rounded-t-3xl bg-white border w-full p-4">
          <div className=" flex items-center justify-between px-6">
            <div className=" relative">
              {select === "dashboard" && (
                <div className=" absolute -ms-3 -bottom-7 bg-primary rounded-3xl w-12 p-2 " />
              )}
              <img
                src={select === "dashboard" ? dashboardActive : dashboard}
                alt="dashboard"
                onClick={() => setSelect("dashboard")}
                className=" cursor-pointer"
              />
            </div>
            <div className=" relative">
              {select === "createproject" && (
                <div className=" absolute -ms-3 -bottom-7 bg-primary rounded-3xl w-12 p-2 " />
              )}
              <img
                src={
                  select === "createproject"
                    ? createProjectActive
                    : createProject
                }
                alt="create"
                onClick={() => setSelect("createproject")}
                className=" cursor-pointer"
              />
            </div>
            <div className=" relative">
              {select === "projectlist" && (
                <div className=" absolute -ms-3 -bottom-7 bg-primary rounded-3xl w-12 p-2 " />
              )}{" "}
              <img
                src={select === "projectlist" ? projectListActive : projectList}
                alt="list"
                onClick={() => setSelect("projectlist")}
                className=" cursor-pointer"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="content lg:ms-8">
        {select === "dashboard" ? (
          <Header page={"Dashboard"} />
        ) : select === "projectlist" ? (
          <Header page={"Project Listing"} />
        ) : select === "createproject" ? (
          <Header page={"Create Project"} />
        ) : null}

        <main className=" flex justify-center items-center mt-16 lg:mt-0 lg:ms-20 ">
          <div className="lg:ms-4 rounded-2xl lg:m-8 m-4 lg:-mt-8 lg:h-screen lg:z-20">
            {renderComponent()}
          </div>
        </main>
      </div>
    </div>
  );
};

export default Admin;
